import { vObject, type vOutput, vString } from '../validation/index.ts'

export const nmfcSearchSchema = vObject({
  description: vString('Description is required for NMFC search'),
})

export const nmfcArticleSchema = vObject({
  code: vString('NMFC code is required'),
})

export type NmfcSearchRequest = vOutput<typeof nmfcSearchSchema>
export type NmfcArticleRequest = vOutput<typeof nmfcArticleSchema>

export type NmfcSearchResponseItem = {
  nmfcNumber: number
  description: string
  grouping: string
  isHazardous: boolean
}
export type NmfcSearchResponse = Array<NmfcSearchResponseItem>

export type MinMax = {
  min: {
    value: number
    exclusive: boolean
  }
  max: {
    value: number
    exclusive: boolean
  }
}

export type NmfcSubItem = {
  subNumber: number
  density: MinMax
  dim?: MinMax
  freightClass: number
  description: string
}

export type NmfcArticleResponse = {
  freightClass?: number
  effectiveDate?: string
  cancelationDate?: string
  description: string
  isHazardous: boolean
  isCanceled: boolean
  canceledReference?: string
  subItems: NmfcSubItem[]
  grouping: string
}

export const isValidNmfcLength = (code: string) => {
  if (!code) return false
  const normalized = code.replace(/^0+/, '') // trim leading zeros
  return normalized.length >= 3 && normalized.length <= 10
}
